<template>
    <div v-if="mode === 'background'"
        @error="onError"
        @click="$emit('click', $event)"
        :style="{ backgroundImage: `url('${url}')` }"
        class="cover-img"></div>
    <img v-else
        @error="onError"
        @click="$emit('click', $event)"
        :alt="alt"
        :data-src="url"
        class="full-img lazyload"
        ref="lazyImage">
</template>

<script>
    import V from 'voUtils/V.js';

    var modes = {
    	'FIT_EXACT': 1,
    	'FIT_TO_WIDTH': 2,
    	'FIT_TO_HEIGHT': 3
    };

    export default {
    	voVueComponent: 'img-fallback',
    	props: {
    		mode: String,
    		alt: String,
    		base: String,
    		imgFormat: String,
    		imgWidth: String,
    		imgHeight: String,
    		imgMode: String,
    		imgScaleUp: String,
    		prefix: String,
    		placeholder: String,
    		img: Number
    	},
    	data() {
    		return {
    			failed: false
    		};
    	},
    	computed: {
    		url() {
    			var lang = VOFFICE.lang;
    			var picture;

    			switch (lang) {
    				case 'de':
    					picture = "15041399.jpg";
    					break;
    				case 'en':
    					picture = "15041401.jpg";
    					break;
    				case 'it':
    					picture = "15041403.jpg";
    					break;
    				case 'fr':
    					picture = "15041402.jpg";
    					break;
    				case 'nl':
    					picture = "15041404.jpg";
    					break;
    				default:
    					picture = "15041400.jpg";
    			}

    			var url, format;
    			var id = this.img;

    			if (id) {
    				url = this.base || '//dyn.v-office.com/image/';
    				format = this.imgFormat || 'p.mtn';

    				if (this.imgWidth && this.imgHeight) {
    					format = 'c.' + this.imgWidth + '.' + this.imgHeight;
    				}

    				if (this.imgScaleUp || this.imgMode) {
    					format += '.' + (this.imgScaleUp === 'true' ? '1' : '0');
    				}

    				if (this.imgMode) {
    					format += '.' + (modes[this.imgMode] || '0');
    				}

    				if (this.prefix) {
    					id = this.prefix + id;
    				}
    				url = url + format + '/' + id + '.webp';

    			} else {
    				url = 'https://dyn.v-office.com/image/';

    				if (this.imgFormat) {
    					url += this.imgFormat;
    				} else {
    					url += 'mx';
    				}

    				url += '/' + picture;
    			}

    			return url;
    		}
    	},
    	watch: {
    		url(newUrl, oldUrl) {
    			this.reloadImage();
    		}
    	},
    	methods: {
    		onError() {
    				this.failed = true;
    			},
    			reloadImage() {
    				const imgElement = this.$refs.lazyImage;
    				if (imgElement) {
    					imgElement.classList.remove('lazyloaded');
    					imgElement.classList.add('lazyload');
    				}
    			}
    	}
    };
</script>